import React, { Suspense, useEffect, useState } from "react";
import "react-confirm-alert/src/react-confirm-alert.css";
import { useSelector, useDispatch } from "react-redux";
import { Routes, Route, useNavigate } from "react-router-dom";
import Loader from "./components/Loader";
import { getUserId, setToken } from "./redux/actions/document";
import { datadogRum } from '@datadog/browser-rum';
import moment from "moment";
import VideoKyc from "./components/VideoKyc";
import OtpVerify from "./components/OtpVerify";
const PresentAddressForm = React.lazy(() => import("./components/presentAddressForm"));
const AadhaarNumber = React.lazy(() => import("./components/aadhaarNumber"));
const PasswordScreen = React.lazy(() => import("./components/password"));
const PanCardDetails = React.lazy(() => import("./components/detailsPANcard"));
const CkycDetails = React.lazy(() => import("./components/ckycDetails"));
const Otp = React.lazy(() => import("./components/ckycOTP"));
const DigiStatus = React.lazy(() => import("./components/digiStatus"));

const CaptureTipsPage = React.lazy(() =>
import("./components/captureTipsPage")
);

const urlParams = new URLSearchParams(window.location.search);

let only_ekyc = urlParams.get("only_ekyc")

function AppRoutes() {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const ekyc = useSelector((state) => state.ekyc);
  
  const [token] = useState(urlParams.get("token") || ekyc.token);
  const [web_ekyc_redirect] = useState(urlParams.get("web_ekyc_redirect"));
  const [panNumber, setPanNumber] = useState("");
  const [dob, setDob] = useState("");
  const [mobileNumber, setMobileNumber] = useState("");
  const [userInfo, setUserInfo] = useState({});

  useEffect(() => {
    localStorage.setItem('web_ekyc_redirect', web_ekyc_redirect);
    
    dispatch(getUserId({ token }))
      .then((result) => {
        localStorage.setItem('userId', result.data.user_id);
        setDob(result.data.dob);
        setPanNumber(result.data.pan_card_number);
        setMobileNumber(result.data.phone_number);
        setUserInfo(result);
        
        // Set user ID in Datadog RUM
        if (result.data.user_id) {
          datadogRum.setUser({
            id: result.data.user_id,
          });
        }
      })
      .catch((err) => {
      });
    
    dispatch(setToken({ token }));
  }, [token, web_ekyc_redirect, dispatch]);

  return (
    <Suspense fallback={<div className="react_loading"><Loader /></div>}>
      <Routes>
        <Route path="/adharnumber" element={<AadhaarNumber />} />
        <Route path="/password" element={<PasswordScreen />} />
        <Route path="/capturetips" element={<CaptureTipsPage />} />
        <Route 
          path="/" 
          element={
            <PanCardDetails 
              panNumber={panNumber} 
              dob={dob} 
              mobileNumber={mobileNumber} 
              result={userInfo} 
              only_ekyc={only_ekyc}
              nbfcName={userInfo?.data?.nbfc_name}
            />
          } 
        />
        <Route path="/ckyc" element={<CkycDetails />} />
        <Route path="/otp" element={<Otp />} />
        <Route path="/address" element={<PresentAddressForm />} />
        <Route path="/video-kyc" element={<VideoKyc />} />
        <Route path="/otp-verify" element={<OtpVerify />} />
        <Route path="/digi-status" element={<DigiStatus />} />
      </Routes>
    </Suspense>
  );
}

export default AppRoutes;